import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CodeInfo } from '../../../services/apiTypes';

type PFCodeTableProps = {
  pfCodes: {
    p: CodeInfo;
    f: CodeInfo;
  }[];
};

const columns = [
  { label: 'LBL_P_CODE', width: '15%', padding: '1rem 0 1rem 10%' },
  { label: 'LBL_P_DETAIL', width: '35%', padding: '1rem' },
  { label: 'LBL_F_CODE', width: '15%', padding: '1rem' },
  { label: 'LBL_F_DETAIL', width: '35%', padding: '1rem 10% 1rem 0' },
];

const PFCodeTable: React.FC<PFCodeTableProps> = ({ pfCodes }) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map(({ label, width, padding }, i) => (
              <TableCell
                key={`p_f_code_header_${i}`}
                sx={{ width, p: padding }}
              >
                {t(label)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {pfCodes.map(({ p, f }, i) => (
            <TableRow key={`p_f_code_${i}`}>
              <TableCell
                sx={{ width: columns[0].width, p: columns[0].padding }}
              >
                {p.code}
              </TableCell>
              <TableCell
                sx={{ width: columns[1].width, p: columns[1].padding }}
              >
                {p.detail}
              </TableCell>
              <TableCell
                sx={{ width: columns[2].width, p: columns[2].padding }}
              >
                {f.code}
              </TableCell>
              <TableCell
                sx={{ width: columns[3].width, p: columns[3].padding }}
              >
                {f.detail}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PFCodeTable;
